// These correspond to the variants for Content Cards
// The variant styles are in styles/backgrounds.scss
// To apply these properly you will need variant style on the parent then an inline svg with class bgSvg
// ie <div class="indigoCard"><svg class="bgSvg">...</svg></div>
export const getVariantStyle = (variant: string): string => {
  switch (variant) {
    case "indigo":
    case "mauve":
    case "blue":
    case "teal":
      return `${variant}Card`;
    default:
      return "";
  }
};

// Map level rank names to color variants for consistent level-based coloring
export const getColorForLevel = (rankName: string): string => {
  switch (rankName?.toLowerCase()) {
    case "white": // Foundational
      return "indigo";
    case "yellow": // Intermediate
      return "blue";
    case "green": // Advanced
      return "teal";
    default:
      return "mauve";
  }
};
